export default __webpack_public_path__ + "static/media/payrun.338d7f0a.png";